const Theme = {
    body_background_color: '#00AAAD',

    header_padding: '10',

    logo_image_url: 'vernonbc.png',
    logo_height: 81,

    button_color: '#74C043',
    button_hover_color: '#68AF3B',
    button_hover_text_color: '#FFF',
    button_font: `'Arial', sans-serif`,
    button_width: 390,
    button_centered: true,

    button_half_border_color: '#74C043',

    text_font: `'Arial', sans-serif`,

    title_font: `'Arial', sans-serif`,

    subtitle_font: `'Arial', sans-serif`,
  }

  export default Theme
